import template from './in-house-sale.jade';
import inHouseAdditional from '../../../enums/in-house-additional';

export default angular
    .module('cian.addForm.inHouseSale', [])
    .directive('cianAfAboutObjectInHouseSale', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function () {
            this.checkboxes = inHouseAdditional;
        }],
        controllerAs: 'inHouseSale',
        template,
    }))
    .name;
